export default {
    "driverStatusCreateEdit_editTitle": "Actualizar",
    "driverStatusCreateEdit_createTitle": "Crear estado de conductor",
    "driverStatusCreateEdit_success": "Exitoso",
    "driverStatusCreateEdit_successMessage": "Estado de conductor guardado",
    "driverStatusCreateEdit_name": "Nombre",
    "driverStatusCreateEdit_notAllowedName": "Este nombre no está disponible",
    "driverStatusCreateEdit_accumulateTime": "Acumular tiempo"
};